import config from "../../../../config";
import { ResponseDto } from '../../../../dtos/common/responseDto';
import { deleteData, getData, patchData, postData } from '../../../../utils/axios/serverHelper';
import { formatDate } from '../../../../utils/string/stringUtil';
import axios from 'axios';

import { KSK2110_R01LotDto, KSK2110_R01Dto, KSK2110_R01HeaderDto, KSK2110_R01InspectDto, KSK2110_R01ProductResultDto, KSK2110_R01DetailDto, KSK2110_R01LotSearchDto } from './Dto_KSK2110_R01';
import { KSK2110_R01Filter } from "./Store_KSK2110_R01";

const baseUrl = `${config.apiUrl}/KSK2110_R01`;

const getParams = (filter: Partial<KSK2110_R01Filter>, listLength?: number) => {	
	return {
		labelPrintAuto: filter.labelPrintAuto || undefined,
		listLength: listLength || 0
	}
}

export const getKSK2110_R01List = async (option: string, params: Partial<KSK2110_R01Filter>, listLength: number = 0) => {

	const url = `${baseUrl}/${option}`;

	return await getData<ResponseDto<KSK2110_R01HeaderDto[]>>(url, { params: getParams(params, listLength) });
}

export const getKSK2110_R01AllCount = async (params: Partial<KSK2110_R01Filter>) => {
    const url = `${baseUrl}/allCount`;

    return await getData<ResponseDto<number>>(url, {
        params: getParams(params, 0)
    });
}

// PRD형: 작업지시번호 기준 단건 조회
export const getKSK2110_R01One = async (productOrderNo: string) => {
	const url = `${baseUrl}/one/${productOrderNo}`;
	return await getData<ResponseDto<KSK2110_R01HeaderDto>>(url);
}

// 기존: productResult/${productOrderNo}/${productWorkNo}
// PRD형: productResult/${productOrderNo}
export const getKSK2110_R01ProductResultList = async (productOrderNo: string) => {
	const url = `${baseUrl}/productResult/${productOrderNo}`;
	return await getData<ResponseDto<KSK2110_R01ProductResultDto>>(url);
}

export const getKSK2110_R01LotList = async (itemCd: string) => {
	const url = `${baseUrl}/lot/${itemCd}`;

	return await getData<ResponseDto<KSK2110_R01LotDto[]>>(url);
}

export const getKSK2110_R01LotSearch = async (data: KSK2110_R01LotSearchDto) => {
	const url = `${baseUrl}/lot/modal`;

	return await getData<ResponseDto<KSK2110_R01LotSearchDto>>(url, { params: data });
}

export const getKSK2110_R01DetailList = async (itemCd: string, productQty: number, badQty: number, outWarehouseCd: string, logicCenter: string, workplaceCd: string) => {
	const url = `${baseUrl}/detail`;

	return await getData<ResponseDto<KSK2110_R01DetailDto[]>>(url, { params: { 
			itemCd: itemCd,
			productQty: productQty,
			badQty: badQty,
			outWarehouseCd: outWarehouseCd,
			logicCenter: logicCenter,
			workplaceCd: workplaceCd
		} 
	});
}

export const getKSK2110_R01DetailStockList = async (itemCd: string, outWarehouseCd: string, logicCenter: string) => {
	const url = `${baseUrl}/detail/stock`;

	return await getData<ResponseDto<KSK2110_R01DetailDto[]>>(url, { params: { 
			itemCd: itemCd,
			outWarehouseCd: outWarehouseCd,
			logicCenter: logicCenter
		} 
	});
}

export const getKSK2110_R01TransportedInfo = async (productResultNo: string) => {
	const url = `${baseUrl}/detail/transported`;
	return await getData<ResponseDto<KSK2110_R01DetailDto[]>>(url, {
		params: {
			productResultNo: productResultNo
		}
	});
}

export const getKSK2110_R01InspectList = async (productResultNo: string) => {
	const url = `${baseUrl}/inspect/${productResultNo}`;

	return await getData<ResponseDto<KSK2110_R01InspectDto[]>>(url);
}

export const createKSK2110_R01LotNo = async () => {
	const url = `${baseUrl}/lot/createLotNo`;
	return await getData<ResponseDto<string>>(url);
}

export const postKSK2110_R01 = async (data: KSK2110_R01Dto) => {

	const url = `${baseUrl}`;

	return await postData<KSK2110_R01Dto, ResponseDto<KSK2110_R01Dto>>(url, data);
}

export const patchKSK2110_R01 = async (data: KSK2110_R01Dto) => {

	console.log('patchKSK2110_R01 data.wmsStockLotDtoList:', data.wmsStockLotDtoList);

	const url = `${baseUrl}`;

	return await patchData<KSK2110_R01Dto, ResponseDto<KSK2110_R01Dto>>(url, data);
}

// 키오스크 전용 — 식별키를 productOrderNo로 통일 (기존: productWorkNo)
export const patchKSK2110_R01WorkStart = async (productOrderNo: string, timeParam: string) => {
	const url = `${baseUrl}/workStart`;
	const data = { productOrderNo: productOrderNo, timeParam: timeParam } as KSK2110_R01HeaderDto;
	return await patchData<KSK2110_R01HeaderDto, ResponseDto<KSK2110_R01HeaderDto>>(url, data);
}

export const patchKSK2110_R01WorkEnd = async (productOrderNo: string, timeParam: string) => {
	const url = `${baseUrl}/workEnd`;
	const data = { productOrderNo: productOrderNo, timeParam: timeParam } as KSK2110_R01HeaderDto;
	return await patchData<KSK2110_R01HeaderDto, ResponseDto<KSK2110_R01HeaderDto>>(url, data);
}

export const deleteKSK2110_R01 = async (purchaseBillNo: string) => {

	const url = `${baseUrl}`;

	return await deleteData<ResponseDto<any>>(url, {
		params: {
			purchaseBillNo
		}
	});
}

export const downloadExcel_KSK2110_R01 = async (option: string, purchaseBillNo: string, listLength: number = 0) => {
	const url = `${baseUrl}/excel/${option}`

	return await getData<ResponseDto<string>>(url, {
		params: {
			purchaseBillNo
		}
	})
}
export const printKSK2110_R01 = async (purchaseBillNo: string) => {
	const url = `${baseUrl}/print`;
	const response = await getData<Blob>(url, {
	  params: { purchaseBillNo },
	  responseType: "blob",
	});
	const fileBlob = new Blob([response.data], { type: "application/pdf" });
	const fileURL = URL.createObjectURL(fileBlob);
	window.open(fileURL, "_blank");
  };
